"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blankManualTriggerTemplate = void 0;
const blankManualTriggerTemplate = () => [
    {
        id: 0,
        version: '1.0.1',
        variables: {
            input: [],
            output: [],
        },
        data: {
            stepName: 'Manual Trigger',
            triggers: [
                {
                    id: 0,
                    type: 'manual',
                },
            ],
        },
        type: 'start',
        next: null,
    },
];
exports.blankManualTriggerTemplate = blankManualTriggerTemplate;
//# sourceMappingURL=blankManualTrigger.js.map